import PatientFeedback from '../pages/governance/feedback/forms/PatientFeedback'
import Dashboard from '../pages/patientRecords/reporting/Dashboard'
import EPCRView from '../pages/patientRecords/reporting/EPCRView/EPCRView'
import PaperPCRView from '../pages/patientRecords/reporting/PaperPCRView/PaperPCRView'
import UninjuredReportView from '../pages/patientRecords/reporting/UninjuredReportView/UninjuredReportView'
import UploadPaperPRF from '../pages/patientRecords/reporting/UploadPaperPRF'
import EpcrAudits from '../pages/patientRecords/audits/EpcrAudits'
import ImagingRequests from '../pages/patientRecords/imaging/ImagingRequests'
import DopsHome from '../pages/patientRecords/dops/DopsHome'
import DopsDetail from '../pages/patientRecords/dops/DopsDetail'
import GovernanceDops from '../pages/patientRecords/dops/GovernanceDops'

export default [
  { path: '/patient-report-forms', element: <Dashboard />, title: 'Patient Report Forms' },
  { path: '/patient-records/audits', element: <EpcrAudits />, title: 'ePCR Audits' },
  { path: '/patient-records/imaging', element: <ImagingRequests />, title: 'Imaging Requests' },
  { path: '/dops', element: <DopsHome />, title: 'DOPS & Logbook' },
  { path: '/dops/:id', element: <DopsDetail />, title: 'DOPS' },
  { path: '/governance/dops', element: <GovernanceDops />, title: 'DOPS & Logbooks' },
  {
    path: '/patient-report-forms/upload-paper-prf',
    element: <UploadPaperPRF />,
    title: 'Upload paper PCR'
  },
  { path: '/patient-report-forms/paper/:id', element: <PaperPCRView />, title: 'Patient Care Record' },
  { path: '/patient-report-forms/ucr/:id', element: <UninjuredReportView /> },
  { path: '/patient-report-forms/:id', element: <EPCRView />, title: 'Patient Care Record' },
  { path: '/patient-feedback', element: <PatientFeedback />, title: 'Patient Feedback' },
  { path: '/patient-feedback/:token', element: <PatientFeedback /> },
]
